import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Utms from '../../shared/models/utm/utms';
import { CookieService } from '../cookie/cookie.service';

@Injectable({ providedIn: 'root' })
export class UtmService {
  private readonly cookieDurationDays = 30;

  constructor(
    private route: ActivatedRoute,
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  public captureAndStoreUtms(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    this.route.queryParams.subscribe((params) => {
      const utms = {
        utm_source: params['utm_source'] || params['gad_source'],
        utm_medium: params['utm_medium'],
        utm_campaign: params['utm_campaign'] || params['gad_campaignid'],
        utm_content: params['utm_content'] || params['gbraid'],
        utm_term: params['utm_term'] || params['gclid'] || params['wbraid'],
      };

      Object.entries(utms).forEach(([key, value]) => {
        if (value?.toString().trim()) {
          this.cookieService.setCookie(key, value, this.cookieDurationDays);
        }
      });

      if (!utms.utm_source && !this.cookieService.hasCookie('utm_source')) {
        this.cookieService.setCookie(
          'utm_source',
          'direto',
          this.cookieDurationDays
        );
      }

      if (!utms.utm_term && !this.cookieService.hasCookie('utm_term')) {
        this.cookieService.setCookie(
          'utm_term',
          'WhatsApp RM',
          this.cookieDurationDays
        );
      }
    });
  }

  public getUtmData(): Utms {
    return {
      utmSource: this.cookieService.getCookie('utm_source') || '',
      utmMedium: this.cookieService.getCookie('utm_medium') || '',
      utmCampaign: this.cookieService.getCookie('utm_campaign') || '',
      utmContent: this.cookieService.getCookie('utm_content') || '',
      utmTerm: this.cookieService.getCookie('utm_term') || '',
    };
  }
}
